import { Stack } from "@mui/material"
import Container from "@mui/material/Container"
import { useTranslation } from "react-i18next"

import CardWithTitle from "widgets/common/CardWithTitle"
import CustomLink from "widgets/common/CustomLink"
import PageTitle from "widgets/common/PageTitle"
import { HeaderContainer } from "widgets/styled/containers"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

export default function ProductDocs() {
  const { i18n, t } = useTranslation()
  const userLanguage = i18n.resolvedLanguage

  useDocumentTitle(t("pageTitles.PRODUCT_MANUALS"))

  return (
    <Container maxWidth="xl" disableGutters>
      <HeaderContainer>
        <PageTitle text={t("pageTitles.PRODUCT_MANUALS")} />
      </HeaderContainer>
      <Stack maxWidth="xl" sx={{ pt: 2, gap: 2 }}>
        <CardWithTitle titleKey={"documentation.INSTALLATION_GUIDES"}>
          <Stack gap={1}>
            <CustomLink
              href={
                userLanguage?.includes("es")
                  ? "https://docs.google.com/presentation/d/1A8V1OZowakn0RxcPs2XtoCPMPyI-eP6QJfBWKMMfExU/preview"
                  : "https://docs.google.com/presentation/d/1l5I9k6vg4RuNcsDZrADTeLUb7_cRB3jL4ET_c3FepjM/preview"
              }
              target="_blank"
              underlineHover
            >
              Sentri Line guard 4.0
            </CustomLink>
            <CustomLink
              href={
                userLanguage?.includes("es")
                  ? "https://docs.google.com/presentation/d/1x8tvMlZKqpIUDwMMLHE9EcL0laLFxosbggvzQxlhJI0/preview"
                  : "https://docs.google.com/presentation/d/1ueAF2prc7FcFiz4w3kdgzFpo1KD8cDGbmuICurF_KzM/preview"
              }
              target="_blank"
              underlineHover
            >
              Sentri Line guard 2.0 / 3.0
            </CustomLink>
          </Stack>
        </CardWithTitle>
        <CardWithTitle titleKey={"documentation.USER_MANUALS"}>
          <Stack gap={1}>
            <CustomLink
              href={
                userLanguage?.includes("es")
                  ? "https://docs.google.com/document/d/1hkU25wpSaR_mWB9vg3poVNGiCD89hdbgV0gUffJXonU/preview"
                  : "https://docs.google.com/document/d/1Uv39-gluwBHpI_Og9DGJdFRBqtT5HW7do85fHWr0cRw/preview"
              }
              target="_blank"
              underlineHover
            >
              Sentri Line guard 4.0
            </CustomLink>
            <CustomLink
              href={
                userLanguage?.includes("es")
                  ? "https://docs.google.com/document/d/13qdEg8c1vP20BV5kspVclT1jjndrFcXQ46UOcxj_nMY/preview"
                  : "https://docs.google.com/document/d/1RCNFxf3uvYhEl8ATBz9Ego2utD2LKW_RiOTabYnGM34/preview"
              }
              target="_blank"
              underlineHover
            >
              Sentri Line guard 2.0 / 3.0
            </CustomLink>
            <CustomLink
              href={
                "https://docs.google.com/presentation/d/1wJaZlcJn8RKEjTsAeVHD08XOisFgzsWWU6sJPCFQthM/preview"
              }
              target="_blank"
              underlineHover
            >
              {t("documentation.DASHBOARD")}{" "}
            </CustomLink>
          </Stack>
        </CardWithTitle>
      </Stack>
    </Container>
  )
}
